import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { voidRemittanceInstruction } from '../api/remittance-instructions.ts';

export default function useVoidRemittanceInstruction(): UseMutationResult<
  string,
  Error,
  string
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => voidRemittanceInstruction(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['confirmedBillings'] });
      queryClient.invalidateQueries({ queryKey: ['remittanceInstructions'] });
    },
  });
}
